export enum ModelMappingRules {
  // One to One
  CreateNew = 1,
  UpdateCreate = 2,
  UpdateIgnore = 3,
  // One to Many
  AddToCollection = 4,
  DisconnectAndAddToCollection = 5,
  DeleteAndAddToCollection = 6,
  UpdateOrAddToCollection = 7,
  // Conditional
  FormPrepopulation = 8,
  MatchUpdateRelationship = 9,
  MatchReplaceRelationship = 10,
  MatchAndAddToCollection = 11,
  MatchAndReplaceCollection = 12,
}

export const ModelMappingRuleLabels = {
  // One to One
  [ModelMappingRules.CreateNew]: 'Create New',
  [ModelMappingRules.UpdateCreate]: 'Update if Exists, Otherwise Create',
  [ModelMappingRules.UpdateIgnore]: 'Update if Exists, Otherwise Ignore',
  // One to Many
  [ModelMappingRules.AddToCollection]: 'Add to Collection',
  [ModelMappingRules.UpdateOrAddToCollection]: 'Update if Exists, Otherwise Add to Collection',
  [ModelMappingRules.DisconnectAndAddToCollection]: 'Disconnect Existing, and Add to Collection',
  [ModelMappingRules.DeleteAndAddToCollection]: 'Delete Existing, and Add to Collection',
  // Conditional
  [ModelMappingRules.FormPrepopulation]: 'Form Prepopulation',
  [ModelMappingRules.MatchUpdateRelationship]: 'Match and create additional relationships (junctions)',
  [ModelMappingRules.MatchReplaceRelationship]: 'Match and create relationship, or replace existing',
  [ModelMappingRules.MatchAndAddToCollection]: 'Match and add to collection',
  [ModelMappingRules.MatchAndReplaceCollection]: 'Match and replace collection',
};

export const ModelMappingCreationRules = [
  ModelMappingRules.CreateNew,
  ModelMappingRules.UpdateCreate,
  ModelMappingRules.AddToCollection,
  ModelMappingRules.UpdateOrAddToCollection,
  ModelMappingRules.DisconnectAndAddToCollection,
  ModelMappingRules.DeleteAndAddToCollection
]

export const ModelMappingUpdateRules = [
  ModelMappingRules.UpdateCreate,
  ModelMappingRules.UpdateIgnore,
  ModelMappingRules.UpdateOrAddToCollection,
]

export const ModelMappingMatchRules = [
  ModelMappingRules.MatchReplaceRelationship,
  ModelMappingRules.MatchUpdateRelationship
]

export const ModelMappingMatchCollectionRules = [
  ModelMappingRules.MatchAndAddToCollection,
  ModelMappingRules.MatchAndReplaceCollection
]

export const ModelMappingAllMatchRules = [
  ...ModelMappingMatchRules,
  ...ModelMappingMatchCollectionRules,
]

export const ModelMappingCantAddValues = [
  ModelMappingRules.MatchAndAddToCollection,
  ModelMappingRules.MatchAndReplaceCollection,
  ModelMappingRules.MatchReplaceRelationship
]